import { Button, Card, CardContent, Chip, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { useEffect } from "react"
import { useForm } from "react-hook-form";
import { apiConstants, post } from "../../common/constants"
import { FormProvider, RHFSelectField, RHFTextField } from "../../common/hook-form";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { useState } from "react";
import { formatDateandDate } from "../../common/util";
import { formatCurrency, formatNumber } from "../../helpers/UtilityHelper";
import { LoadingButton } from "@mui/lab";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import "../Wallet/theme.css";
import MUIModal from "../../components/MuiModal";
import { useSnackbar } from "notistack";
import _ from "lodash";
import PageTitle from "../../components/PageTitle";
import Loader from "../../common/Loader";
import HistoryIcon from '@mui/icons-material/History';

function CloseCODRemittance() {
    const [data, setData] = useState([])
    const [filterData, setFilterData] = useState({
        yearAndMonth: null,
        year: null,
        createdDateSort: "DESC",
    });
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(20);
    const [rows, setRow] = useState([])
    const [reload, setReload] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const [logs, setLogs] = useState([])
    const [logsOpen, setLogsOpen] = useState(false)

    const handleOpen = (data) => {
        setLogsOpen(true)
        setLogs(data)
    }

    const handleClose2 = () => {
        setLogsOpen(false)
        setLogs([])
    };


    const Month = [{
        label: "January",
        value: "01"
    },
    {
        label: "February",
        value: "02"
    },
    {
        label: "March",
        value: "03"
    },
    {
        label: "April",
        value: "04"
    },
    {
        label: "May",
        value: "05"
    },
    {
        label: "June",
        value: "06"
    },
    {
        label: "July",
        value: "07"
    },
    {
        label: "August",
        value: "08"
    },
    {
        label: "September",
        value: "09"
    },
    {
        label: "October",
        value: "10"
    },
    {
        label: "November",
        value: "11"
    },
    {
        label: "December",
        value: "12"
    }
    ]

    const columns = [
        {
            field: 'Merchant',
            renderCell: ({ row }) => (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {row.merchantName}
                    </Grid>
                </Grid>
            ),
            flex: 1.2
        },
        {
            field: 'From Date',
            renderCell: ({ row }) => formatDateandDate(row.fromDate),
            flex: 1

        },
        {
            field: 'To Date',
            renderCell: ({ row }) => formatDateandDate(row.toDate),
            flex: 1
        },
        {
            field: 'Total Orders',
            renderCell: ({ row }) => formatNumber(row.totalOrders),
            flex: 0.8
        },
        {
            field: 'COD Amount',
            renderCell: ({ row }) => formatCurrency(row.totalCODAmount),
            flex: 1
        },
        {
            field: 'Status',
            align: 'center',
            renderCell: ({ row }) => (<Chip
                label={row.reportStage}
                size="small"
                sx={{
                    fontSize: '12px',
                    fontWeight: 600,
                    backgroundColor: row.reportStage === 'APPROVED' ? '#008000' : row.reportStage === 'PARTIALLY_PAID' ? '#ED553B' : "#ffa500",
                    color: 'white'
                }}
            />),
            flex: 1
        },
        {
            field: 'Remitted Amount',
            renderCell: ({ row }) => row?.amountRemittedToMerchant ? formatCurrency(row?.amountRemittedToMerchant) : "-",
            flex: 1
        },

        {
            field: 'Early COD',
            renderCell: ({ row }) => row?.isEarlyCODReport ? 'Yes' : '-',
            flex: 0.8
        },
        {
            field: 'Commission Percent',
            renderCell: ({ row }) => row?.earlyCODComissionPercent ? formatNumber(row.earlyCODComissionPercent) + " %" : " - ",
            flex: 0.8
        },
        {
            field: 'Commission Amount',
            renderCell: ({ row }) => row?.commissionAmt ? formatCurrency(row?.commissionAmt) : "-",
            flex: 0.8
        },
        {
            field: 'Total Tax',
            renderCell: ({ row }) => row?.earlyCODTotalTax ? formatCurrency(row?.earlyCODTotalTax) : "-",
            flex: 0.8
        },
        {
            field: 'Total Payable',
            renderCell: ({ row }) => row?.totalCODAsPerEarlyCOD ? formatCurrency(row?.totalCODAsPerEarlyCOD) : "-",
            flex: 0.8
        },
        {
            field: 'Held Amount',
            renderCell: ({ row }) => row?.amountRemittedToMerchant && row?.amountRemittedToMerchant < row?.totalCODAmount ? formatCurrency(row?.totalCODAmount - row?.amountRemittedToMerchant) : "-",
            flex: 0.8
        },
        {
            field: 'Action',
            flex: 1.2,
            renderCell: ({ row }) => {
                const role = ["PARTIALLY_PAID"]
                const verified = _.intersection([row.reportStage], role)
                return (
                    <>
                        <Grid container rowSpacing={1}>
                            <>
                                <Grid item xs={12} sx={{ display: 'flex' }}>
                                    {verified?.length > 0 && (
                                        <>
                                            <Tooltip title="Remitt">
                                                <IconButton
                                                    onClick={() => handleRemit(row)} >
                                                    <CurrencyRupeeIcon fontSize="small"
                                                        color="info" variant="contained"
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </>
                                    )}
                                    {row.actionsHistory?.length > 0 &&
                                        <Tooltip title="Action Logs">
                                            <IconButton
                                                onClick={() => handleOpen(row?.actionsHistory)} >
                                                <HistoryIcon fontSize="small"
                                                    color="info" variant="contained"
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </Grid>
                            </>
                        </Grid>
                    </>
                )
            }
        }

    ]

    const [remit, setRemit] = useState(false)
    const handleRemit = (row) => {
        setRow(row)
        setRemit(true)
    }

    const methods = useForm({
        defaultValues: {
            merchant: '',
            year: '',
            month: ''
        }
    });

    const { handleSubmit, reset } = methods;

    const onSubmit = (data) => {
        setFilterData({
            merchantId: data.merchant,
            yearAndMonth: data.year + data.month,
            year: data.year,
            createdDateSort: "DESC",
            reportStageIn: data.status
        })
    }


    const handleClose = () => {
        setRemit(false)
    };

    useEffect(() => {
        setIsLoading(true)
        filterData.skip = page * sizePerPage;
        filterData.limit = sizePerPage;
        filterData.reportStageIn = "PARTIALLY_PAID"
        post(apiConstants.COD_MERCHANT_REPORT, filterData
        ).then((res) => {
            setIsLoading(false)
            // only store data where totalCODAmount is greater than 0
            const filtereData = res.data?.responseObj?.filter(item => item?.totalCODAmount > 0 && item.paymentStatusAudit?.length > 0)
            setData(filtereData)
        }).catch(err => {
            setIsLoading(false)
            console.error(err)
        })
    }, [reload, sizePerPage, page, filterData])


    const ActionLogcolumns = [
        {
            field: 'action',
            headerName: 'Action',
            flex: 1.5,
        },
        {
            field: 'actionedBy',
            headerName: 'Actioned By',
            flex: 1.5,
        },
        {
            field: 'actionTime',
            headerName: 'Action Time',
            flex: 1,
            renderCell: (row) => {
                return formatDateandDate(row?.row?.actionTime);
            }
        }
    ]



    const handleApprove = () => {
        post(apiConstants.COD_ACTION, {
            "reportId": rows?.id,
            "merchantId": rows?.merchantRef,
            "dateRangeKey": rows?.dateRangeKey,
            "action": "REMIT"
        }).then((res) => {
            if (res.data?.status === "SUCCESS") {
                enqueueSnackbar(res.data?.responseObj, { variant: 'success' })
                setReload(reload + 1)
                setRemit(false);
            }
            else {
                enqueueSnackbar(res.data?.errorMsg, { variant: 'error' })
                setRemit(false);
            }
        })
            .catch((err) => console.log(err))
    }


    return (
        <>
            {isLoading && <Loader />}
            <PageTitle>Close COD Remittance</PageTitle>
            <MUIModal open={logsOpen} handleClose={handleClose2} children={
                <ProzoDataGrid
                    columns={ActionLogcolumns}
                    autoHeight={true}
                    rows={logs || []}
                    rowCount={logs?.length || 0}
                    getRowId={(row) => Math.random()}
                    hideFooterPagination={true} />
            }
                title={`Action Logs`} />
            <MUIModal open={remit} handleClose={handleClose} children={
                <Typography>
                    Are you sure you want to proceed with remitting the COD amount to this merchant? This action is irreversible and cannot be undone.
                </Typography>}
                title={"Confirmation"} maxWidth="md" action={
                    <Button onClick={handleApprove} autoFocus color='success' variant="contained">
                        Agree
                    </Button>} />
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Card sx={{ mb: 2 }}>
                    <CardContent>
                        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                            <Grid item xs={12} md={3}>
                                <MerchantFilterCached />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <RHFSelectField name='month' label='Select Month' width={'100%'} options={Month.map((val) => ({
                                    value: val.value,
                                    label: val.label
                                }))} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <RHFTextField name='year' label='Year' />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <LoadingButton
                                    variant="contained"
                                    size="medium"
                                    type="submit"
                                >Submit</LoadingButton>
                                <Button onClick={() => {
                                    reset({
                                        merchant: '',
                                        year: '',
                                        month: '',
                                    })
                                    setFilterData({
                                        yearAndMonth: null,
                                        year: null,
                                        createdDateSort: "DESC",
                                    })
                                    setReload(reload + 1)
                                }}
                                    variant="contained" color='error' size="medium" sx={{ ml: 1 }}>Reset</Button>


                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>
            </FormProvider>
            <Grid>
                <ProzoDataGrid
                    columns={columns}
                    autoHeight={true}
                    rows={data || []}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    setPage={setPage}
                    page={page}
                    pagination={true}
                    hideFooterPagination={false}
                    filterMode={"server"}
                    rowHeight={120}
                    rowCount={Number.MAX_VALUE}
                    getRowId={(row) => row.id}
                />
            </Grid>
        </>
    )
}

export default CloseCODRemittance